import React, {Component} from 'react';
import AppliedFilter from "./AppliedFilter";
import {connect} from "react-redux";
import Translator from "../../helpers/Translator";
import {DOMAIN} from "../FilterContainer";

class AppliedFilterList extends Component {
    renderList() {
        let list = [];
        Object.keys(this.props.appliedFilters.groups).map((filter) => {
            if (this.props.appliedFilters.groups[filter].enabled) {
                list.push(<AppliedFilter key={filter} filter={this.props.appliedFilters.groups[filter]}/>);
            }

            return true;
        });

        return list;
    }

    render() {
        const translator = new Translator(this.props.translator, DOMAIN);
        const list = this.renderList();

        if (list.length === 0) {
            return null;
        }

        return (
            <div>
                <div className="clearfix d-none d-lg-block mb-2">
                    <div className="applied-filter-title text-muted">{translator.trans('Filters applied')}: </div>
                    {this.renderList()}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        appliedFilters: state.FilterGroupsReducer,
        translator: state.TranslationsReducer.translations
    }
}

export default connect(mapStateToProps)(AppliedFilterList);



// WEBPACK FOOTER //
// ./src/components/appliedFilters/AppliedFilterList.js